(function ($) {
    $(document).on("ready", function () {
        $("a.tab")
            .on("click", function (e) {
                e.preventDefault();
                var $tab = $(e.currentTarget);
                var $activeTab = $tab.parents(".tabs").find(".tab.active");
                var $activeTarget = $($activeTab.attr("data-target"));
                var targetID = $tab.attr("data-target");
                var $target = $(targetID);
                $activeTab.removeClass("active");
                $activeTarget.removeClass("active");
                $tab.addClass("active");
                $target.addClass("active");
                $(window).trigger("thee.tab.active", $tab);
            });
    });
})(jQuery);